export default "__VITE_ASSET__U0U4zQzG__"